export interface UserContext {
  userId: string;
  role: 'admin' | 'user' | 'organization_user' | 'locations_user';
  organizationId: string;
  locationIds?: string[];
}

export function isLocationScopedContext(userContext: UserContext | undefined): boolean {
  return userContext?.role === 'locations_user' && (userContext.locationIds?.length ?? 0) > 0;
}